const state = {
	detail : {},
	matchDetail : {},
	initSearch (){},
	initLikeSearch (){},
	listData : [],
	historyStore : [], // 历史选中的门店
	editStoreIds: [], // 我的订单审核代入弹窗的id
	drillParentListRefresh:false,// 钻取列表的父页刷新
	drillListRefresh: false, // 钻取列表刷新
	drillActive:false, // 记录下单弹框的打开和关闭，仅仅用在钻取所用
	drillParentActive:false, // 记录下钻取列表框的打开和关闭，仅仅用在钻取所用
	isRefreshSingal:false, // 记录一键下单弹框触发的单款订货列表的刷新
	scrollGoodsId:0, // 钻取的时候记录商品id，下次回来滚动到当前商品位置
}

const mutations = {
	changeSingalDetail (state,payload){
		state.detail = payload;
	},
	changeIsRefreshSingal (state,payload){
		state.isRefreshSingal = payload;
	},
	changeSingalMatchDetail (state,payload){
		state.matchDetail = payload;
	},
	changeSingalList (state,payload){
		state.listData = payload;
	},
	changeSingalInitFunc (state,payload){
		state.initSearch = payload;
	},
	changeSingalInitLikeFunc (state,payload){
		state.initLikeSearch = payload;
	},
	changeDrillListRefresh(state,payload) {
		state.drillListRefresh = payload;
	},
	changeDrillParentListRefresh(state,payload) {
		state.drillParentListRefresh = payload;
	},
	changeDrillActiveRefresh(state,payload) { // 记录下单弹框的打开和关闭
		state.drillActive = payload;
	},
	changeDrillParentActiveRefresh(state,payload) { // 钻取列表弹框的打开和关闭
		state.drillParentActive = payload;
	},
	changeScrollGoodsId(state,payload) {
		state.scrollGoodsId = payload;
	},
	changeHistoryStore(state,payload){
		state.historyStore = payload;
	},
	changeEditStoreIds(state,payload){
		state.editStoreIds = payload;
	},
}

export default {
	state,
	mutations
}



// WEBPACK FOOTER //
// ./src/storage/vuex/module/singalDialog.js